module.exports = __webpack_public_path__ + "img/empreendedorismo-no-ambiente-escolar.5da4943a.jpg";